export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin || 'http://localhost:3000',
    postLogoutRedirectUri: window.location.origin || 'http://localhost:3000',
  },
  cache: {
    // SEC-19: sessionStorage, not localStorage. MSAL's cache holds the access
    // token this app sends as its API bearer (SEC-26; the ID token before that)
    // plus the Graph access/refresh
    // tokens; in localStorage that material is readable by any script that
    // ever runs in this origin AND survives the tab, so one XSS gets a
    // credential with a long shelf life. sessionStorage narrows it to the
    // life of the tab, and matches the investor portal's JWT, which already
    // uses sessionStorage (InvestorPortal.js:26/127).
    //
    // Accepted trade: the cache is no longer shared across tabs, so a new
    // tab or window starts with an empty cache. It does NOT mean a second
    // login prompt — the Azure AD session cookie on login.microsoftonline.com
    // is untouched, so MSAL's silent redirect re-populates the new tab's
    // cache without user interaction (frame-src/connect-src for that host are
    // allowed by the CSP in server.js). Cross-tab SSO is not a requirement
    // here; if it ever becomes one, the fix is not localStorage.
    //
    // One-time deploy effect: every staff session's existing localStorage
    // cache is orphaned, so everyone re-authenticates once after this ships.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// ── SEC-26: this API's own scope ──────────────────────────────────────
// The app registration exposes api://<client-id>/access_as_user and
// pre-authorizes this SPA, so MSAL can mint an ACCESS token for it silently.
// Previously the app sent response.idToken as the API bearer — an identity
// assertion with no resource scoping, so any client of the same app
// registration held the same API power.
const API_CLIENT_ID = process.env.REACT_APP_AZURE_AD_CLIENT_ID || '';
export const API_SCOPE = `api://${API_CLIENT_ID}/access_as_user`;

// Interactive login stays on Graph's User.Read. One token request cannot span
// two resources (AADSTS28000: "more than one resource"), so the API scope is
// NOT added to `scopes` — it rides in extraScopesToConsent, which gets it
// consented during login without asking Azure AD to put it in the same token.
// With the SPA pre-authorized this is belt-and-braces; it costs nothing and
// removes a class of first-login silent-acquire failure.
export const loginRequest = {
  scopes: ['User.Read'],
  extraScopesToConsent: [API_SCOPE],
};

// What the axios interceptor and the /users/me bootstrap ask for.
// `response.accessToken` from THIS request is the API bearer.
export const apiRequest = {
  scopes: [API_SCOPE],
};

export const graphCalendarRequest = {
  scopes: ['Calendars.ReadWrite'],
};

export const graphContactsRequest = {
  scopes: ['Contacts.ReadWrite'],
};

export const graphMailRequest = {
  scopes: ['Mail.Read'],
};
